import Vue from 'vue';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';

import Toast from 'vue-toastification';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

import 'vue-toastification/dist/index.css';

import App from './App.vue';
import router from './router';
import setupHttp from './http';

// Design system — must stay the last style import so it overrides
// Bootstrap/BootstrapVue and per-view legacy styles.
import './assets/theme.css';

Vue.config.productionTip = false;
Vue.use(Chartkick.use(Chart));

// Dark-theme friendly Chart.js defaults (display only): light labels and
// subtle gridlines so charts stay readable on the dark background.
Chart.defaults.global.defaultFontColor = '#a0a4ae';
Chart.defaults.global.defaultFontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, Roboto, 'Helvetica Neue', Arial, sans-serif";
Chart.defaults.scale.gridLines.color = 'rgba(255, 255, 255, 0.06)';
Chart.defaults.scale.gridLines.zeroLineColor = 'rgba(255, 255, 255, 0.2)';

// Global API auth handling: redirect to login on 401 across all requests.
setupHttp(router);

Vue.use(Toast, { hideProgressBar: true });
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
